import { Field, pairFields } from "./AssociateFields";
import { STEP_TITLES, fieldsFor } from "./associateSpec";

const SECTION = { general: "General Information", entity: "Entity Details", photo: "Photo ID Details", comm: "Communication Details",
  nominee: "Nominee Details", bank: "Bank Details", license: "License Details", cert: "Certification", other: "Other Details", commercials: "Commercials" };

export const TabSections = ({ steps, draft, setStep, ro, errs, ctx, profile }) => (
  <div className="space-y-8">
    {steps.map((s) => {
      const fields = fieldsFor(s, ctx);
      if (!fields.length) return null;
      return (
        <section key={s} className="space-y-3" data-testid={`associate-step-${s}`}>
          <h3 className="text-xs font-bold uppercase tracking-wider text-teal-700" title={STEP_TITLES[s]}>{SECTION[s]}</h3>
          <div className="grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-3">
            {pairFields(fields).map(({ fl, attach }) => (
              <Field key={fl.key} fl={fl} attach={attach} data={draft[s] || {}} set={(p) => setStep(s, p)} ro={ro} errs={errs[s] || {}} ctx={ctx} />
            ))}
          </div>
          {s === "license" && ["CA", "CS", "OTHER"].includes((draft.general || {}).profession) && (
            <p className="text-xs text-slate-500">ARN/EUIN are taken from the Introduced By associate.</p>
          )}
        </section>
      );
    })}
  </div>
);
